import { Box, Button, Flex, Skeleton, Text } from '@chakra-ui/react';
import type { CardProps } from '@ui/components/Card';
import { Card } from '@ui/components/Card';
import { InDesktop } from '@ui/components/MobileOrDesktop';
import { TokenIcon } from '@ui/components/TokenIcon';
import useVnoBasicInfo from '@ui/hooks/useVnoBasicInfo';
import { useTranslations } from '@ui/i18n';
import { formatNumber } from '@ui/utils/format';
import React from 'react';

import type { VaultType } from '../Vno/ReservoirAndFountain/types';

type LockVnoSmallCardProps = {
  type: VaultType;
  active?: boolean;
} & CardProps;

const LockVnoSmallCard = ({
  type,
  active,
  ...props
}: LockVnoSmallCardProps) => {
  const t = useTranslations();
  const { isLoading, maxApr } = useVnoBasicInfo(type);
  const isReservoir = type === 'RESERVOIR';
  const name = isReservoir ? 'Reservoir' : 'Fountain';

  return (
    <Card
      mx="0"
      my={2}
      flex={1}
      isActive={active}
      p={2}
      cursor="pointer"
      {...props}
    >
      <Flex gap={1}>
        <TokenIcon token={type === 'RESERVOIR' ? 'cro' : 'vno'} />
        <Flex flexDir="column" color="text.light">
          <Text textStyle="bodyBold" color="text.normal">
            {name}
          </Text>
        </Flex>
      </Flex>
      <Box mt={1} textStyle="body" color="text.light">
        {!isLoading ? (
          t('Up to {num} in {coin}', {
            num: `${formatNumber(maxApr * 100, 0)}% APR`,
            coin: type === 'RESERVOIR' ? 'CRO' : 'VNO',
          })
        ) : (
          <Skeleton display="inline-block" h="19px" w="50px" />
        )}
      </Box>
      <InDesktop>
        <Button size="sm" mt="12px">
          {t('Deposit in {platform}', {
            platform: name,
          })}
        </Button>
      </InDesktop>
    </Card>
  );
};
export default LockVnoSmallCard;
